// OK 06/11/2024

import { useEffect, useState } from "react";
import CalendarContext from "../../../context/CalendarContext";
import { Chantier, Planning } from "../../../interfaces";
import { getColorPlanning } from "../../../utils/getColorPlanning";

export default function CalendarProvider(props: { children: any }) {
  const [refreshCalendar, setRefreshCalendar] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(true);
  const colorPlanning = getColorPlanning();
  const [chantier, setChantiers] = useState<Chantier[]>([]);
  const [chantierLoadingFinish, setChantierLoadingFinish] = useState(false);
  const [planning, setPlanning] = useState<Planning[]>([]);

  useEffect(() => {
    setIsLoadingModal(true);
    const fetchData = async () => {
      try {
        const resolvedColorPlanning = await colorPlanning;
        setChantiers(resolvedColorPlanning);
      } catch (error) {
        console.error(
          "Une erreur s'est produite lors de la résolution de la promise.",
          error
        );
      }
    };

    fetchData();
    setIsLoadingModal(false);
  }, [refreshCalendar == true]);

  return (
    <CalendarContext.Provider
      value={{
        refreshCalendar,
        setRefreshCalendar,
        chantier,
        isLoadingModal,
        setIsLoadingModal,
        setChantierLoadingFinish,
        chantierLoadingFinish,
        planning,
        setPlanning,
      }}
    >
      {props.children}
    </CalendarContext.Provider>
  );
}
